import React, { useEffect, useState } from 'react'
import { IoCheckmark } from "react-icons/io5";
import { FaTimes } from 'react-icons/fa';

const DebateChat = ({name,stance, metrics, factCheckSummary}) => {

  const [distribution, setDistribution] = useState({
    correct : 0,
    inCorrect : 0
  })

  useEffect(() => {
    const upVotedTotal = factCheckSummary ? factCheckSummary.filter(({argument}) => {
      return argument === "correct"
    }).length : 0

    const downVotedTotal = factCheckSummary ? factCheckSummary.filter(({argument}) => {
      return argument === "incorrect"
    }).length : 0

    setDistribution({
      correct : upVotedTotal,
      inCorrect : downVotedTotal
    })

  },[factCheckSummary])


  return (
    <div className='pr-4'>
    <div className='flex  flex-col md:flex-row md:justify-between  md:gap-2  md:items-center'>
      <h3 className='font-bold my-2'>{name}</h3>
    </div>
      <div className='my-2'>
        <div className='font-nunito'>{stance}</div>
      </div> 

      {metrics &&
      <div className='flex flex-row gap-2 space-x-4 mb-2'>
            <div className='flex flex-row space-x-1 h-3 items-center'>
              <p>{distribution.correct}</p>
              <div className='text-green-200'>
                <IoCheckmark />
              </div>
            </div>
            <div className='flex flex-row space-x-1 h-3 items-center'>
              <p>{distribution.inCorrect}</p>
              <div className='text-red-400'>
                <FaTimes />
              </div>
            </div>
          </div>
      }

      
    </div>
  )
}

export default DebateChat